/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListHirersResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'Hirer',
        },
        isRequired: true,
      },
    },
  }],
} as const;
